import { Utils } from "./utils";
/**
 * Setup Reviews Review Date text with time difference between todays datetime and the date of purchase.
 * @param reviews The Array of reviews to be updated.
 */
function setupReviews(reviews) {
    reviews.forEach((review) => {
        // Find the purchase date field.
        const reviewDate = review.querySelector('.purchase-date');
        if (reviewDate == null || reviewDate.textContent == '')
            return;
        const dateStr = reviewDate.textContent;
        if (dateStr == null)
            return;
        // Find the Review Date field
        const target = review.querySelector('.date-string .review-date');
        // Update the Review Date field with the Human readable time difference text e.g. 1 month ago.
        if (target != null) {
            target.textContent = Utils.timeAgo(dateStr);
        }
    });
}
export class ReviewPageReviews {
    /**
     * Setup the review container HTMLElements review values, accordions and paging.
     * @param reviewContainer The review container to be setup.
     */
    static setupReviewContainer(reviewContainer) {
        const reviews = reviewContainer.querySelectorAll('.review');
        setupReviews(reviews);
        const reviewAccordians = reviewContainer.querySelectorAll('.review-extras');
        ReviewPageReviews.setupReviewAccordians(reviewAccordians);
    }
    /**
     * Update the accordions of the reviews and attach an event listener to the expansion button.
     * @param accordians The Array of accordions to be updated with the expansion click listener.
     */
    static setupReviewAccordians(accordians) {
        accordians.forEach((accordian) => {
            const expandBtn = accordian.querySelector(`.read-more`);
            if (expandBtn == null)
                return;
            expandBtn.addEventListener('click', () => {
                accordian.classList.toggle('active');
            });
        });
    }
}
